import { env, Runtime } from './env';

/**
 * Name: CAT异常监控
 */
class Monitor {
  private config: any = {};
  private isDev: boolean = true;

  constructor(isDev: boolean) {
    if (!Owl) {
      return;
    }
    this.isDev = isDev;
    this.init();
    Owl.start(this.config);
  }

  init() {
    this.config = {
      project: 'com.sankuai.fspfepayresource.dcep.activity',
      pageUrl: `${location.origin}${location.pathname}${location.hash}`,
      devMode: this.isDev,
      resource: {
        sampleApi: 1,
        delay: 0
      },
      page: {
        auto: true,
        sample: 1,
        delay: 0
      },
      error: {
        sample: 1,
        combo: false
      },
      ajax: {
        flag: true,
        duration: 8000
      },
      metric: {
        sample: 1,
        combo: true
      },
      logan: {
        enable: true,
        Logan: (window as any).Logan
      },
      ignoreList: {
        js: [
          'Illegal return statement',
          'SyntaxError: Return statements are only valid inside functions.',
          'c35 is not defined'
        ]
      }
    };
  }
  /**
   *level: 异常等级，可选可选 error、warn 和 info
   *category: 异常分类，可选 jsError、ajaxError、resourceError 和 customError
   */
  captureMessage(error: string | SubErrorType, config = {} as ICatErrorModel) {
    const baseConfig: ICatErrorModel = {
      level: 'info',
      category: 'customError'
    };

    // 上报 自定义类别 错误异常
    Owl.addError(error, {
      ...baseConfig,
      ...config
    });
  }

  reportMetric(key: string, tags = {}, value?: any): void {
    const metricManager = Owl.metricManager;
    metricManager.setTags({
      ...tags
    });
    metricManager.setMetric(key, value || 1);
    // 强制上报所有
    metricManager.report();
  }

  sendPoint(position: number) {
    // 在CAT后台展示时index N对应的是自定义性能点N+1
    if (Owl && Owl.addPoint && Owl.sendPoints) {
      Owl.addPoint({
        position,
        duration: Date.now() - window.performance.timing.navigationStart || undefined
      });
      // 发送数据
      Owl.sendPoints();
    }
  }
}

const isProduct = env.runtime === Runtime.Prod;

export const monitor = new Monitor(!isProduct);
